import React from "react";
import { isEmpty } from "lodash";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import CircularProgress from "@mui/material/CircularProgress";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import Table from "examples/Tables/Table";
import GoalActionButton from "layouts/goals/components/GoalActionButton";
import GoalPill from "layouts/goals/components/GoalPill";
import { ROLES_COLUMNS, ROLES_MESSAGES } from "../roles.constants";

function RolesTable({ roles, onEdit, onDelete, isLoading }) {
  const rows = roles.map((role) => {
    const deleteBlocked = role.is_protected
      ? ROLES_MESSAGES.superAdminProtected
      : role.is_system
      ? ROLES_MESSAGES.builtInNoDelete
      : role.admin_count > 0
      ? `${role.admin_count} user${role.admin_count > 1 ? "s have" : " has"} this role`
      : null;
    return {
      role: (
        <SuiBox display="flex" alignItems="center" gap={1} px={1} py={0.5}>
          <SuiTypography variant="button" fontWeight="medium">
            {role.name}
          </SuiTypography>
          {role.is_system && <GoalPill color="secondary">Built-in</GoalPill>}
        </SuiBox>
      ),
      features: role.is_protected ? (
        <GoalPill color="success">All features</GoalPill>
      ) : (
        <SuiTypography variant="caption" color="secondary">
          {role.permissions.length} feature{role.permissions.length === 1 ? "" : "s"}
        </SuiTypography>
      ),
      users: (
        <SuiTypography variant="caption" color="secondary">
          {role.admin_count}
        </SuiTypography>
      ),
      actions: (
        <SuiBox display="flex" gap={1} justifyContent="center">
          <GoalActionButton
            icon="edit"
            tooltip={role.is_protected ? ROLES_MESSAGES.superAdminProtected : "Edit role"}
            color="info"
            disabled={role.is_protected}
            onClick={() => onEdit(role)}
          />
          <GoalActionButton
            icon="delete"
            tooltip={deleteBlocked || "Delete role"}
            color="error"
            disabled={!!deleteBlocked}
            onClick={() => onDelete(role)}
          />
        </SuiBox>
      ),
    };
  });

  return (
    <Card>
      <SuiBox p={3}>
        {isLoading ? (
          <SuiBox display="flex" justifyContent="center" alignItems="center" py={4}>
            <CircularProgress color="dark" size={30} />
          </SuiBox>
        ) : !isEmpty(rows) ? (
          <Table columns={ROLES_COLUMNS} rows={rows} />
        ) : (
          <SuiBox
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            py={4}
          >
            <Icon fontSize="large" color="secondary" sx={{ opacity: 0.5 }}>
              admin_panel_settings
            </Icon>
            <SuiTypography variant="button" color="text" fontWeight="regular" mt={1}>
              {ROLES_MESSAGES.empty}
            </SuiTypography>
          </SuiBox>
        )}
      </SuiBox>
    </Card>
  );
}

export default RolesTable;
